export const localeConstants = {
  LOCAL_UPDATE: 'LOCAL_UPDATE',
};
